import {
  Backdrop, Button, CircularProgress, colors, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tab, Tabs,
  BottomNavigationAction, BottomNavigation, Paper, Snackbar
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import Page from 'src/components/Page';
import getTenantFeatureVisibility from 'src/utils/tenantFeatureVisibility';
import { loadBaslandiJob, removeBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { getDefectRequest, getLabourRequest, getMaterialRequest } from '../../store/actions';
import { addDefects, resetDefects } from '../../store/actions/defectActions';
import { addLabours, resetLabours } from '../../store/actions/labourActions';
import { addMaterials, resetMaterials } from '../../store/actions/materialActions';
import AiSuggestion from './AiSuggestion';
import Bulten from './Bulletin';
import Yorum from './Comment';
import Hizmet from './Defect';
import Aciklama from './Detail';
import Digiport from './Digiport';
import Sonlandir from './FinalProcess';
import Header from './Header';
import Yardimci from './Helper';
import Tarihce from './History';
import Fotograf from './Photo';
import Yazdir from './Print';
import Urun from './Product';
import Summary from './Summary';
import Garanti from './Warranty';
import Degisim from './ProductChange';
import Payment from './Payment';
import TamamlayiciUrunSatis from './ComplementaryProductSales';
import AttachmentIcon from '@material-ui/icons/Attachment';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import BuildIcon from '@material-ui/icons/Build';
import SendIcon from '@material-ui/icons/Send';
import TechnicalSupport from './TechnicalSupport';
import Operations from './Operations';
import axios from 'src/utils/axios';
import {
  getUser,
} from 'src/utils/Common';
import TechnicianSurvey from './TechnicianSurvey';
import TestsComponent from 'src/components/TestsComponent';
import Tests from './Tests';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  tabs: {
    marginTop: theme.spacing(1)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(3)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function Isler({
  match, history, tasks, resetDefects, resetLabours, resetMaterials, addDefects, addLabours, addMaterials, getDefectRequest, getLabourRequest, getMaterialRequest,
}) {
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const [Loading, setLoading] = useState(true);
  const [readonly, setReadonly] = useState(true);
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const { id, tab: currentTab } = match.params;
  const [BottomValue, setBottomValue] = useState(null);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [ResponseType, setResponseType] = useState('success');
  const [ResponseDsc, setResponseDsc] = useState('');
  const [IsHitachiCountry, setIsHitachiCountry] = useState(false);
  const SessionUser = getUser();
  const [billingConsumer, setBillingConsumer] = useState(null);
  const [HasTechnicianSurvey, setHasTechnicianSurvey] = useState(false);
  const [technicianSurveys, setTechnicianSurveys] = useState([]);
  const [isAPACTenant, setIsAPACTenant] = useState(null);

  const Alltabs = [
    {
      value: 'AiSuggestion', index: -1, label: t('Ai_Suggestion'), visible: isAPACTenant === false, component: <AiSuggestion WorkOrderId={id} readonly={readonly} />
    },
    {
      value: 'summary', index: 0, label: t('Musteri'), visible: true, component: <Summary ReceiptNo={id} readonly={readonly} />
    },
    {
      value: 'Aciklama', index: 1, label: t('Aciklama'), visible: true, component: <Aciklama ReceiptNo={id} readonly={readonly} />
    },
    {
      value: 'Tarihce', index: 2, label: t('Tarihce'), visible: true, component: <Tarihce ReceiptNo={id} readonly={readonly} />
    },
    {
      value: 'Urun', index: 3, label: t('Urun'), visible: true, component: <Urun ReceiptNo={id} readonly={readonly} />
    },
    {
      value: 'Garanti', index: 4, label: t('Garanti'), visible: true, component: <Garanti ReceiptNo={id} billingConsumer={billingConsumer} setBillingConsumer={setBillingConsumer} readonly={readonly} />
    },
    {
      value: 'Bulten', index: 5, label: t('Kutuphane'), visible: true, component: <Bulten ReceiptNo={id} readonly={readonly} />
    },
    {
      value: 'Yardimci', index: 6, label: t('T_Destek'), visible: true, component: <TechnicalSupport ReceiptNo={id} readonly={readonly} setOpenSnackbar={setOpenSnackbar} setResponseDsc={setResponseDsc} setResponseType={setResponseType} />
    },
    {
      value: 'Hizmet', index: 7, label: t('Hizmet'), visible: true, component: <Hizmet ReceiptNo={id} readonly={readonly} />
    },
    {
      value: 'Degisim', index: 11, label: t('Degisim'), visible: true, component: <Degisim ReceiptNo={id} readonly={readonly} />
    },
    // { value: 'Anket', index: 13, label: t('Anket'), visible: false, component: <Anket ReceiptNo={id} readonly={readonly} /> },
    {
      value: 'Sonlandir', index: 14, label: t('Sonlandir'), visible: true, component: <Sonlandir ReceiptNo={id} readonly={readonly} setBillingConsumer={setBillingConsumer} setReadonly={setReadonly} techSurveysToCheck={technicianSurveys} />
    },
    // {
    //   value: 'Payment', index: 21, label: t('Payment'), visible: true, component: <Payment ReceiptNo={id} readonly={readonly} />
    // },
    {
      value: 'Fotograf', index: 10, label: t('Fotograf'), visible: true, component: <Fotograf ReceiptNo={id} readonly={readonly} />
    },
    (IsHitachiCountry || SessionUser.TenantId === 59) ? {
      value: 'Operations', index: 20, label: t('lblOperations'), visible: true, component: <Operations ReceiptNo={id} readonly={readonly} />
    } : '',
    {
      value: 'Yazdir', index: 15, label: t('Yazdir'), visible: true, component: <Yazdir ReceiptNo={id} readonly={readonly} />
    },
    {
      value: 'Yorum', index: 18, label: t('Yorum'), visible: true, component: <Yorum ReceiptNo={id} readonly={readonly} />
    },
    {
      value: 'Digiport', index: 20, label: t('Digiport'), visible: true, component: <Digiport ReceiptNo={id} readonly={readonly} />
    },
    // {
    //   value: 'Tests', index: 21, label: t('Tests'), visible: true, component: <Tests ReceiptNo={id} readonly={readonly} />
    // },
    HasTechnicianSurvey ? {
      value: 'TechnicianSurvey', index: 20, label: t('Anket'), visible: true, component: <TechnicianSurvey workorderId={id} readonly={readonly} loadedSurveys={technicianSurveys} />
    } : ''
    // { value: 'TamamlayiciUrunSatis', index: 21, label: t('Tamamlayici'), visible: true, component: <TamamlayiciUrunSatis ReceiptNo={id} readonly={readonly} /> },
  ];

  const tabs = Alltabs.filter((t) => t.visible).map((t, i) => ({ ...t, index: i }));


  useEffect(() => {

    getHitachiCountry();
    getTechnicianWorkOrderSurveys(id);
  }, []);

  useEffect(() => {
    getTenantFeatureVisibility()
      .then((visibility) => setIsAPACTenant(visibility.IsAPACTenant))
      .catch(() => setIsAPACTenant(true));
  }, []);


  const getHitachiCountry = () => {
    axios
      .get(
        `/GetLoanProductCountry/${parseInt(SessionUser.TenantId)}`
      )
      .then(response => {
        if (response.data == false) {
          setIsHitachiCountry(false);
        } else {
          setIsHitachiCountry(true);
        }
      })
      .catch(error => {
      });
  };


  const getTechnicianWorkOrderSurveys = (workOrderId) => {
    axios
      .get(
        `/GetTechnicianSurveys/${workOrderId}`
      )
      .then(response => {
        if (response.data == null || response.data.StatusCode != 200) {
          setHasTechnicianSurvey(false);
          console.error("An error occured while fetching surveys for technicians. Please check error logs.");
        } else {
          if (response.data.Result.length > 0) {
            setHasTechnicianSurvey(true);
            setTechnicianSurveys(response.data.Result);
            var results = response.data.Result;
            if (results.some(e => e.IsCompleted === false)) {
              alert("Attention. Customer survey(s) found to fill out with your customers before proceeding. Thank you.");
            }
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  };



  const handleChangeIndex = (index) => {
    const indexValueId = tabs.filter((d) => d.index === index)[0].value;
    history.push(`/WorkOrder/${id}/${indexValueId}`);
  };
  const handleChange = (event, value) => {
    const indexValue = tabs.filter((d) => d.index === value)[0].value;
    history.push(`/WorkOrder/${id}/${indexValue}`);
  };








  const handleClose = () => {
    setOpen(false);
    history.push('/overview');
  };
  useEffect(() => {
    if (!tasks.loading) {
      const jobs = tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(id));
      if (jobs.length === 0) {
        const informationAlert = t('Fis_Bulunamadi').replace('@FisNo', id);
        setUyari(informationAlert);
        setOpen(true);
      }
      else {


      }
    }
    // eslint-disable-next-line
  }, [history, id, tasks.loading, tasks.tasks]);


  let currentTabIndex = 0;

  if (currentTab !== undefined) {
    var currentTabIndexCheck = tabs.filter((d) => d.value === currentTab)[0];
    if (currentTabIndexCheck != undefined) {
      currentTabIndex = currentTabIndexCheck.index;
    }
  }
  const [index, setindex] = useState(currentTabIndex);

  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      if (mounted) {
        setindex(currentTabIndex);
      }
    };
    fetchTodos();

    return () => {
      mounted = false;
    };
  }, [currentTabIndex]);
  const current = tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(id));
  useEffect(() => {
    if (current && current.length > 0) {
      let curr = current[0];
      if (parseInt(current[0].StatusCode) === 33) {
        setReadonly(false);
        const existingLocal = loadBaslandiJob()[0];
        const isSameOpenWorkOrder = existingLocal && parseInt(existingLocal.ReceiptNo) === parseInt(id);
        // Aynı WO için zaten yerel bir job varsa (teknisyen üzerinde çalışıyor demektir),
        // sunucudan gelen eski snapshot ile üzerine yazıp henüz gönderilmemiş
        // işçilik/arıza/malzeme seçimlerini kaybetmeyelim (bkz. SM-2070059).
        if (!isSameOpenWorkOrder) {
          saveBaslandiJob(current[0]);
        }
        curr = isSameOpenWorkOrder ? existingLocal : current[0];
      } else {
        setReadonly(true);
      }
      const kulModelKodu = curr.ModelCode;
      const garantiTipi = curr.WarrantyTypeId || 0;
      const uyil = curr.ProductionYear || 0;
      const udonem = curr.ProductionMonth || 0;
      const WorkOrderIdParam = curr.ReceiptNo || 0;

      if (kulModelKodu !== undefined && kulModelKodu !== null && kulModelKodu.length > 0) {
        resetDefects();
        resetMaterials();
        resetLabours();
        getDefectRequest(kulModelKodu, garantiTipi);
        getMaterialRequest(kulModelKodu, garantiTipi, 1, uyil, udonem, WorkOrderIdParam);
        getLabourRequest(kulModelKodu, garantiTipi, 1, WorkOrderIdParam);
        if (curr.WorkOrderDetails) {
          const selectedDefects = [];
          let labours = {};
          let materials = {};
          curr.WorkOrderDetails.forEach((h, index) => {
            selectedDefects.push(h.DefectId);
            labours = { ...labours, [h.DefectId]: [] };
            materials = { ...materials, [h.DefectId]: [] };
          });
          addDefects(selectedDefects);
          if (curr.WorkOrderLabours) {
            curr.WorkOrderLabours.forEach((i, index) => {
              labours[i.DefectId].push(i.LabourCode.toString());
            });
            addLabours(labours);
          }
          if (curr.WorkOrderMaterials) {
            curr.WorkOrderMaterials.forEach((i, index) => {
              materials[i.DefectId].push(i.MaterialCode.toString());
              materials = { ...materials, [i.MaterialCode]: i.Count };
            });
            addMaterials(materials);
          }
        }
      }
    }
    setLoading(false);
    // eslint-disable-next-line
  }, [current[0]]);




  return (
    <Page
      className={classes.root}
      title={'Sirius Tech'}
    >
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{t('Bilgilendirme')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      {
        Loading || tasks.loading
          ? (
            <Backdrop className={classes.backdrop} open={Loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
          )
          : (
            <Container maxWidth={false}>
              <Header ReceiptNo={id} readonly={readonly} />
              <Tabs
                value={index}
                className={classes.tabs}
                textColor="secondary"
                scrollButtons="on"
                indicatorColor="primary"
                variant="scrollable"
                onChange={handleChange}
              >
                {
                  tabs.map((t) => t.visible && <Tab key={t.index} label={t.label} value={t.index} />)
                }
              </Tabs>
              <SwipeableViews
                index={index}
                onChangeIndex={handleChangeIndex}
                animateHeight={false}
                animateTransitions={false}
                resistance
              >
                {
                  tabs.map((t) => (
                    <div key={t.index}>
                      {t.visible && currentTab === t.value ? t.component : null}
                    </div>
                  ))
                }
              </SwipeableViews>

            </Container>
          )
      }

      <Paper style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={2}>
        <BottomNavigation
          showLabels
          value={BottomValue}
          onChange={(event, newValue) => {

            setBottomValue(newValue);
            if (newValue === 0) {
              history.push(`/WorkOrder/${id}/Fotograf`);
            }
            if (newValue === 1) {
              history.push(`/WorkOrder/${id}/Bulten`);
            }
            if (newValue === 2) {
              history.push(`/WorkOrder/${id}/Hizmet`);
            }
            if (newValue === 3) {
              history.push(`/WorkOrder/${id}/Sonlandir`);
            }
          }}
        >
          <BottomNavigationAction label={t('Fotograf')} icon={<AttachmentIcon />} />
          <BottomNavigationAction label={t('Kutuphane')} icon={<LocalLibraryIcon />} />
          <BottomNavigationAction label={t('Hizmet')} icon={<BuildIcon />} />
          <BottomNavigationAction label={t('Sonlandir')} icon={<SendIcon />} />
        </BottomNavigation>
      </Paper>

    </Page>


  );
}

Isler.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};


export default connect(
  (state) => ({ tasks: state.tasks1 }),
  {
    resetDefects, resetLabours, resetMaterials, addDefects, addLabours, addMaterials, getDefectRequest, getLabourRequest, getMaterialRequest
  }
)(Isler);
